var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import * as productFactory from '../../../classes/definitions/product/product';
import * as variantFactory from '../../../classes/definitions/product/variant';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import variantSchema from '../../../schemas/variantSchema';
import VariantsService from '../../../services/variants.service';
import Input from '../../UI/Input/Input';
var VariantForm = /** @class */ (function (_super) {
    __extends(VariantForm, _super);
    function VariantForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.productId = '';
        _this.editId = '';
        _this.messages = null;
        _this.variantsService = new VariantsService(_this.api);
        _this.parentProduct = null;
        _this.state = {
            formConfig: _.cloneDeep(variantSchema),
            formIsValid: false,
            parentSuggestions: [],
            giftsSuggestions: [],
        };
        // Setting up the options to all fields that need async data
        // after the options are all set up, then we'll load the data for edit
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            // Getting the parent product info
            _this.parentProduct = productFactory.createProduct(_.get(data, 'product.data.attributes', {}), _.get(data, 'product.data.id', {}));
            // Setting up the Option Value field based on the parent product
            _this.setOptionValueField(updatedFormConfig, _this.parentProduct.OptionType);
            _this.setVariantStatus(updatedFormConfig, _.get(data, 'stock_statuses.stock_statuses'));
            _this.setStatuses(updatedFormConfig, _.get(data, 'statuses.statuses'));
            // this.setupOptionValues(updatedFormConfig, _.get(data, 'optionTypes.data'));
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.getVariant(_this.productId, _this.editId);
                }
            });
        };
        _this.setVariantStatus = function (updatedFormConfig, rawStatuses) {
            for (var key in rawStatuses) {
                if (Object.prototype.hasOwnProperty.call(rawStatuses, key)) {
                    updatedFormConfig.stock_status.elementConfig.options.push(new DropdownOption({
                        label: NotosService.formatStock(key),
                        value: key,
                    }));
                }
            }
        };
        _this.setStatuses = function (updatedFormConfig, rawStatuses) {
            for (var key in rawStatuses) {
                if (Object.prototype.hasOwnProperty.call(rawStatuses, key)) {
                    updatedFormConfig.status.elementConfig.options.push(new DropdownOption({
                        label: NotosService.formatStatuses(key),
                        value: key,
                    }));
                }
            }
        };
        _this.setOptionValueField = function (updatedFormConfig, productOptionType) {
            // If the parent product does not have Option Type specified
            // removing the Option Value field from the variant in both Create and Update cases
            if (!productOptionType) {
                delete updatedFormConfig.option_value;
                return;
            }
        };
        // searches through the api for category that has to be assigned as parent
        _this.suggestOptions = function (event, type) {
            var _a, _b;
            var searchString = event.query.toLowerCase();
            var searchMethod = _this.api.searchGifts;
            if (type === 'gift') {
                searchMethod(searchString)
                    .then(function (response) {
                    var data = _.get(response, 'data.data', []);
                    var results = [];
                    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                        var item = data_1[_i];
                        results.push({
                            label: _.get(item, 'attributes.bg_name', ''),
                            value: _.get(item, 'id'),
                        });
                    }
                    var obj = {};
                    obj['giftsSuggestions'] = results;
                    _this.setState(obj);
                })
                    .catch(function (error) {
                    var defaultMessage = 'Не можахме да намерим опции';
                    _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
                });
            }
            else {
                _this.api
                    .searchOptionValues(((_a = _this.parentProduct) === null || _a === void 0 ? void 0 : _a.OptionType) ? (_b = _this.parentProduct) === null || _b === void 0 ? void 0 : _b.OptionType.toString() : '0', event.query)
                    .then(function (response) {
                    _this.mapSuggestionsToField(_.get(response, 'data.data', []));
                })
                    .catch(function (error) {
                    var defaultMessage = 'Грешка при търсене на Option Value';
                    _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
                });
            }
        };
        _this.mapSuggestionsToField = function (rawData) {
            var controlSuggestions = rawData.map(function (item, key) {
                return new DropdownOption({
                    label: _.get(item, 'attributes.value', ''),
                    value: _.get(item, 'id', '-1'),
                });
            });
            _this.setState({ parentSuggestions: controlSuggestions });
        };
        _this.getVariant = function (productId, variantId) {
            _this.api
                .getVariant(productId, variantId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на вариант';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var _a;
            var variant = variantFactory.createVariant(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _this.variantsService.setDataToForm(updatedFormConfig, variant, (_a = _this.parentProduct) === null || _a === void 0 ? void 0 : _a.OptionType);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elementType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            // The blur methods resets teh autocomplete for some reason
            if (elementType === 'autocomplete' && eventType === 'onBlur') {
                return;
            }
            if (elementType === 'checkbox') {
                updatedFormElement.value = event.checked;
            }
            else if (elementType === 'autocomplete') {
                updatedFormElement.value = event.value;
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            /* const submittedVariant: variantFactory.Variant = variantFactory.createVariant({
                price: _.get(formData, 'price.value', ''),
                old_price: _.get(formData, 'old_price.value', ''),
                status: _.get(formData, 'status.value', ''),
                barcode: _.get(formData, 'barcode.value', ''),
                default: _.get(formData, 'default.value', false),
                packaging: _.get(formData, 'packaging.value', null),
                position: _.get(formData, 'position.value', 50),
                option_value: _.get(formData, 'option_value.value', 0),
                external_id: _.get(formData, 'external_id.value', ''),
                gift: Number(_.get(formData, 'gift.value.value', null)) !== 0 ?Number(_.get(formData, 'gift.value.value', null)) : null
            }); */
            var submittedVariant = {
                "price": _.get(formData, 'price.value', ''),
                "old_price": _.get(formData, 'old_price.value', ''),
                "status": _.get(formData, 'status.value', ''),
                "barcode": _.get(formData, 'barcode.value', ''),
                "default": _.get(formData, 'default.value', false),
                "use_as_main_in_list": _.get(formData, 'use_as_main_in_list.value', false),
                "packaging": _.get(formData, 'packaging.value', null),
                "position": _.get(formData, 'position.value', 50),
                "option_value_id": Number(_.get(formData, 'option_value.value.value', 0)),
                "external_id": _.get(formData, 'external_id.value', ''),
                "gift_id": Number(_.get(formData, 'gift.value.value', null)) !== 0 ? Number(_.get(formData, 'gift.value.value', null)) : null,
                "stock_status": _.get(formData, 'stock_status.value', ''),
                "bg_composition": _.get(formData, 'bg_composition.value', ''),
                "en_composition": _.get(formData, 'en_composition.value', ''),
            };
            var actionMethod = _this.editId === '-1' ? _this.api.createVariant : _this.api.updateVariant;
            actionMethod({ variant: submittedVariant }, _this.productId, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toVariantsPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на вариант';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toVariantsPage = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.productId + AppRoutes.variants.path);
        };
        return _this;
    }
    VariantForm.prototype.componentDidMount = function () {
        var _this = this;
        var api = new ApiRequests();
        this.productId = _.get(this.props, 'match.params.id', '-1');
        this.editId = _.get(this.props, 'match.params.variantId', '-1');
        this.variantsService
            .fetchAsyncFieldsOptions(this.productId)
            .then(function (data) {
            _this.setupFieldsOptions(data);
        })
            .catch(function (error) {
            var defaultMessage = 'Опциите за някое или за всички полета не можаха да бъдат заредени. Опитайте отново!';
            _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
        });
        // load edit value
        if (this.editId !== '-1' && this.productId !== '-1') {
            this.props.isEdit(true); // setting the isEdit to the parent view so the submenu can be loaded
        }
    };
    VariantForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, parentSuggestions = _a.parentSuggestions, giftsSuggestions = _a.giftsSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                }, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); }, suggestions: formElement.id === 'gift' ? giftsSuggestions : parentSuggestions }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toVariantsPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return VariantForm;
}(React.Component));
// @ts-ignore
export default withRouter(VariantForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Variants/VariantForm/VariantForm.tsx
// module id = 504
// module chunks = 0